export default __webpack_public_path__ + "static/media/bearshamanaction.6c5f2609.png";